import { EmailNotificationState, SortMapping } from '../types';
import { daysRange } from 'app/constants/dates';

import { DEFAULT_ROWS_PER_PAGE } from 'app/constants/paginate';

export const emailNotificationState: EmailNotificationState = {
  emailNotifications: [],
  totalRecordCount: 0,
  limit: DEFAULT_ROWS_PER_PAGE,
  pageIndex: 0,
  sortBy: '-event-date',
  sortField: 'eventDate',
  search: '',
  toDate: daysRange.maxDay.toUTC().toISO(),
  fromDate: daysRange.minDay.toUTC().toISO(),
};

export const sortMapping: SortMapping = {
  toAddress: {
    field: 'to-address',
  },
  fromAddress: {
    field: 'from-address',
  },
  subject: {
    field: 'subject',
  },
  content: {
    field: 'content',
  },
  eventDate: {
    field: 'event-date',
  },
};
